import React from 'react';
import { Info } from 'lucide-react';

/**
 * Tells the user that signing back in is simply how activation finishes.
 *
 * Onboarding asks for a re-authentication twice — once after the account is created,
 * once after the workshop is set up — and both screens used to say only *that* it was
 * needed. Being told to sign out right after signing up reads like a bug, at the exact
 * moment a new customer is deciding whether to trust the product.
 *
 * KEEP THE COPY PLAIN. The underlying reason is token scoping (the session token still
 * carries pre-organisation claims — see the comment in OrganisationSetup's
 * handleSubmit), but that is OUR problem, not the customer's. An earlier version of
 * this explained the security property and it was cut deliberately: talking about
 * permissions and sessions on a signup screen invites the reader to wonder what could
 * go wrong, and anything resembling "for your security" makes people think somebody is
 * checking their details and sit waiting for an approval that never comes.
 *
 * Say what happens and that it is the last step. Nothing more.
 */
const AccountActivationNotice = ({ className = '' }) => (
    <div className={`flex gap-3 text-left bg-blue-50 border border-blue-100 rounded-xl p-4 ${className}`}>
        <Info size={18} className="text-blue-500 shrink-0 mt-0.5" />
        <p className="text-xs text-blue-900 leading-relaxed">
            Signing back in is what activates your account &mdash; it&rsquo;s the last
            step, and it takes a moment.
        </p>
    </div>
);

export default AccountActivationNotice;
